import { render, staticRenderFns } from "./ImagenesSatelitalesFooter.vue?vue&type=template&id=15f32244&scoped=true"
import script from "./ImagenesSatelitalesFooter.vue?vue&type=script&lang=ts"
export * from "./ImagenesSatelitalesFooter.vue?vue&type=script&lang=ts"
import style0 from "./ImagenesSatelitalesFooter.vue?vue&type=style&index=0&id=15f32244&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f32244",
  null
  
)

export default component.exports